import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import { Icon } from '@/components/ui/icon';
import { Button } from '@/components/ui/button';

const { FiHome, FiAlertTriangle } = FiIcons;

const NotFound = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="mb-8">
          <Icon icon={FiAlertTriangle} size="3xl" color="warning" className="mx-auto mb-4" />
          <h1 className="text-foreground text-6xl font-bold mb-4">404</h1>
          <h2 className="text-foreground text-2xl font-semibold mb-4">Page Not Found</h2>
          <p className="text-muted-foreground mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="space-y-4">
          <div className="flex justify-center">
            <Button asChild className="gap-2">
              <Link to="/">
                <Icon icon={FiHome} color="white" />
                <span>Back to Dashboard</span>
              </Link>
            </Button>
          </div>

          <div className="flex justify-center space-x-4">
            <Link to="/users" className="text-muted-foreground hover:text-foreground transition-colors">
              Users
            </Link>
            <Link to="/products" className="text-muted-foreground hover:text-foreground transition-colors">
              Products
            </Link>
            <Link to="/settings" className="text-muted-foreground hover:text-foreground transition-colors">
              Settings
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;